<template>
  <div class="container p-3 min-vh-100">
    <div class="flex-grow-1 d-flex flex-column">
      <img
        :src="useAsset('img/credit-line/error_warning_icon.svg')"
        alt="icon"
        class="w-25 mx-auto"
      />

      <h1 class="text-black mt-4">
        {{ t("INSUFFICIENT_WITHDRAWAL_FUNDS.TITLE") }}
      </h1>

      <p>
        {{
          t("INSUFFICIENT_WITHDRAWAL_FUNDS.DESCRIPTION", {
            currencySymbol,
            minimumWithdrawal,
          })
        }}
      </p>
      <p class="mt-4">
        {{
          t("INSUFFICIENT_WITHDRAWAL_FUNDS.AVAILABLE", {
            currencySymbol,
            availableCredit,
          })
        }}
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import { useI18n } from "@/apps/credit-line/composables/useI18n";

export default defineComponent({
  name: "InsufficientWithdrawalFunds",
  methods: { useAsset },
  props: {
    minimumWithdrawal: Number,
    availableCredit: Number,
    currencySymbol: String,
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/constants";

img {
  margin-top: 70%;
}

.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  flex: 1 0 0;
}

h1 {
  color: #111;
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Inter;
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
}

h1 + p {
  color: #666;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Inter;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
}

p + p {
  color: #666;
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Inter;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
}
</style>
